export const requestMixin = {
  data() {
    return {
      requestErrors: {}
    };
  },
  methods: {
    requestError(error, cb = () => {}) {
      if (error.response) {
        this.requestErrors = error.response.data;
      } else if (error.request) {
        this.requestErrors = error.request.data;
      } else {
        /* eslint-disable no-console */
        console.error(error.message);
      }
      return cb(error);
    },
    hasError(key) {
      return (
        this.requestErrors.hasOwnProperty("errors") &&
        this.requestErrors.errors.hasOwnProperty(key)
      );
    },
    getError(key) {
      if (!this.hasError(key)) return [];
      return this.requestErrors.errors[key];
    },
    removeError(key) {
      if (!this.hasError(key)) return;
      return delete this.requestErrors.errors[key];
    }
  }
};
